import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define the state structure for the microplate slice
interface MicroplateState {
  wellsContent: Record<string, Record<string, number>>;
  wellsColors: Record<
    string,
    Record<string, string | number | { value: number }>
  >;
}

// Initial state for the microplate slice
const initialMicroplateState: MicroplateState = {
  wellsContent: {},
  wellsColors: {},
};

// Create the microplate slice
const microplateSlice = createSlice({
  name: "microplate",
  initialState: initialMicroplateState,
  reducers: {
    onUpdateWellsContent: (
      state,
      action: PayloadAction<Record<string, Record<string, number>>>
    ) => {
      state.wellsContent = action.payload;
    },
    onUpdatedWellsColors: (
      state,
      action: PayloadAction<Record<string, Record<string, number>>>
    ) => {
      state.wellsColors = action.payload;
    },
  },
});

// Export the actions and reducer
export const { onUpdateWellsContent, onUpdatedWellsColors } =
  microplateSlice.actions;
export const MicroplateReducer = microplateSlice.reducer;

interface TimerInterface {
  hours: number;
  minutes: number;
  seconds: number;
}

// Initial state for the microplate reader slice
interface MicroplateReaderState {
  temperature: number;
  timer: TimerInterface;
  wavelength: number;
  wellsType: object;
  isShakeOn: boolean;
  isReadPressed: boolean;
}

// Initial state for the microplate reader slice
const initialMicroplateReaderState: MicroplateReaderState = {
  temperature: 18,
  timer: { hours: 0, minutes: 0, seconds: 0 },
  wavelength: 465,
  wellsType: {},
  isShakeOn: false,
  isReadPressed: false,
};

// Create the microplate reader slice
const microplateReaderSlice = createSlice({
  name: "microplateReader",
  initialState: initialMicroplateReaderState,
  reducers: {
    setTemperature: (state, action: PayloadAction<number>) => {
      state.temperature = action.payload;
    },
    setTimer: (state, action: PayloadAction<TimerInterface>) => {
      state.timer = action.payload;
    },
    setWavelength: (state, action: PayloadAction<number>) => {
      state.wavelength = action.payload;
    },
    setIsShakeOn: (state, action: PayloadAction<boolean>) => {
      state.isShakeOn = action.payload;
    },
    onSetWellsType: (state, action: PayloadAction<object>) => {
      state.wellsType = action.payload;
    },
    setIsReadPressed: (state, action: PayloadAction<boolean>) => {
      state.isReadPressed = action.payload;
    },
  },
});

// Export the actions and reducer
export const {
  setTemperature,
  setTimer,
  setWavelength,
  onSetWellsType,
  setIsShakeOn,
  setIsReadPressed,
} = microplateReaderSlice.actions;
export const MicroplateReaderReducer = microplateReaderSlice.reducer;
